<script>
import TableSelect from '@utils/table-select'
import Table from '@utils/table'
import Jurisdiction from '@utils/jurisdiction'
import Dialog from '@utils/common/dialog'
import Form from '@utils/form'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'
import { tableExport, tableImport } from '@/utils'

const tip = {
  props: ['value'],
  methods: {
    download() {
      tableExport({
        url: '/srmQualitativeScore/downloadQualitativeScoreTemplate',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { id: this.value.id },
        name: this.$t('performance.qualitativescore.templateName')
      })
    }
  },
  render() {
    return <div style='font-size: 12px;display: flex; align-items: center;'><el-link type='primary' onClick={this.download}>{this.$t('performance.qualitativescore.download')}</el-link>{this.$t('performance.qualitativescore.importTip')}</div>
  }
}

const fileNoAttrs = {
  autoUpload: false,
  onChange(file) {
    this.$emit('input', file.raw)
  }
}

const dForm = new Form('performance.qualitativescore')
  .setSpan(24)
  .add('fild').component(UploadSelect).col(24).attrs(fileNoAttrs).required()
  .add('info').label('').component(tip)

const dialog = new Dialog('performance.qualitativescore')
  .title('dialogTitle')
  .dialog({ width: '400px' })
  .form(dForm)

async function showImport() {
  const vm = await dialog.open({ attrs: { row: { info: { id: this.$route.params.id }}}})
  const formData = new FormData()
  formData.set('file', vm.data.fild)
  await tableImport({
    url: '/srmQualitativeScore/importCommentScoreExcel',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: formData
  })
  this.reset()
}

const jurisdiction = new Jurisdiction('performance.qualitativescore')
  .add('importTable').icon('icon-daoru').handle(showImport)
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      table: null
    }
  },
  computed: {
    tableComponent() {
      return this.table ? this.table.tpl() : 'div'
    }
  },
  created() {
    const listTable = new Table()
      .edit(true)
      .type('none')
      .sortable(false)
      .add('supOfficeName').label('performance.qualitativescore.supOfficeName')
    const list = this.data.list || []
    const listFormula = this.data.listFormula || []

    listFormula.forEach((label, index) => {
      listTable.add(`item${index}`).label(listFormula[index])
      const item = list[index] || {}
      if (!item.gradeFlag) {
        listTable.format(() => '******')
      } else {
        listTable.editor('el-input-number').bind('controls-position', 'right').bind('min', 0)
      }
    })

    const tableSelect = new TableSelect('performance.qualitativescore')
      .title('tableTitle')
      .table(listTable)
      .jurisdiction(jurisdiction)
    tableSelect.injectForm(this.form)
    this.table = tableSelect
  },
  render(h) {
    return this.table
      ? h(this.tableComponent, { props: { $tableSelect: this.table, prop: 'list', value: this.data.dataList, data: this.data }})
      : h('div')
  }
}
</script>
